import produce from 'immer';
export var initialState = {
    name: null,
    data: '',
    validation: {
        name: null,
        data: '',
    }
};
export var SET_LAYER = 'SET_LAYER';
export var SET_VALIDATION = 'SET_VALIDATION';
export var layerAction = function (_a) {
    var name = _a.name, data = _a.data;
    return ({
        type: SET_LAYER,
        payload: {
            name: name,
            data: data || '' // null로 API 호출시 등록 실패
        }
    });
};
export var validationAction = function (_a) {
    var name = _a.name, data = _a.data;
    return ({
        type: SET_VALIDATION,
        payload: {
            name: name,
            data: data || '' // null로 API 호출시 등록 실패
        }
    });
};
var Reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    return produce(state, function (draft) {
        switch (action.type) {
            case SET_LAYER: {
                draft.name = action.payload.name;
                draft.data = action.payload.data || '';
                break;
            }
            case SET_VALIDATION: {
                draft.validation.name = action.payload.name;
                draft.validation.data = action.payload.data || '';
                break;
            }
            default: {
                break;
            }
        }
    });
};
export default Reducer;



//////////////////
// WEBPACK FOOTER
// ./src/detail/reducers/layer.ts
// module id = 5
// module chunks = 0